import { OrderOperationEntity } from 'api/types/entity';
import { renderDate, renderDateTime } from 'helpers/tableRenders';
import { TFunc, useTranslation } from 'libs/i18n';
import { TableColumn } from 'libs/ui';

import { renderExecutionPlace } from './renders/executionPlace';

interface GetColumnsArgs {
  brokerTimezoneOffset: number;
}

export const getColumns = (
  t: TFunc,
  { brokerTimezoneOffset }: GetColumnsArgs
): TableColumn<OrderOperationEntity>[] => [
  {
    field: 'executedAt',
    title: t('account.order.sections.operationsSection.columns.executedAt'),
    flex: 1,
    minWidth: 224,
    renderCell: (item, field) =>
      renderDateTime(item, field, brokerTimezoneOffset),
  },
  {
    field: 'settlementDate',
    title: t('account.order.sections.operationsSection.columns.settlementDate'),
    flex: 1,
    minWidth: 224,
    renderCell: (item, field) => renderDate(item, field, brokerTimezoneOffset),
  },
  {
    field: 'isin',
    title: t('account.order.sections.operationsSection.columns.isin'),
    flex: 1,
    minWidth: 136,
  },
  {
    field: 'quantity',
    title: t('account.order.sections.operationsSection.columns.quantity'),
    flex: 1,
    minWidth: 104,
  },
  {
    field: 'netUnitPrice',
    title: t('account.order.sections.operationsSection.columns.netUnitPrice'),
    flex: 1,
    minWidth: 184,
  },
  {
    field: 'volume',
    title: t('account.order.sections.operationsSection.columns.volume'),
    flex: 1,
    minWidth: 136,
  },
  {
    field: 'currency',
    title: t('account.order.sections.operationsSection.columns.currency'),
    flex: 1,
    minWidth: 72,
  },
  {
    field: 'executionPlace',
    title: t('account.order.sections.operationsSection.columns.executionPlace'),
    flex: 1,
    minWidth: 220,
    renderCell: (item) => renderExecutionPlace(item),
  },
];

export const useColumns = ({ brokerTimezoneOffset }: GetColumnsArgs) => {
  const { t } = useTranslation();
  const columns = getColumns(t, { brokerTimezoneOffset });

  return columns;
};
